import React from 'react'
import BreadCumb from '../../components/common/Breadcrumb';
import backArrow from "../../assets/task/back_arrow.svg";

const TasksMain = () => {
  return (
    <div id="cts-respon-p-dv" className="w-full  relative gap-[25px] overflow-hidden flex flex-row items-start justify-center flex-wrap content-start py-40 px-20 mq991:p-8 mq575:p-4  box-border text-left text-base text-gray font-manrope">
      <BreadCumb />
      <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl w-full">
        {/* <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
        /> */}
        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">My work</h3>
      </div>
      <div className="m-0 w-full self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
        <h5 className="my-0 text-xl-dv self-stretch relative text-base">Waiting on you right now</h5>

        <div className="mytask-blog-dv viewdoclist_tabel_blg min-w-full overflow-hidden assessorform_main_tbl client-hist-main">
          <div className=" bg-white dark:dark:bg-slate-700 flex flex-col items-start justify-start gap-[24px] overflow-x-auto client-report-dtnamic-tbl">
            <table className="table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv">
              <tbody>
                <tr>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus"><span className="redstatus"></span> W-5102</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv">Magnolia Home Care · Toni</span>
                    <span className="">She asked for a person, twice. Talent drain, 48 clients, opened A5 and not A6.</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv "> <span className="method-status">M14</span> </span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm due-status-bg">
                    <span className="relative commandtbl-top top-removed-dv due-status">58 min left of two hours</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <button className="cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue">
                      <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">Open her map</div></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="m-0 w-full self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
        <h5 className="my-0 text-xl-dv self-stretch relative text-base">Today</h5>

        <div className="mytask-blog-dv viewdoclist_tabel_blg min-w-full overflow-hidden assessorform_main_tbl client-hist-main">
          <div className=" bg-white dark:dark:bg-slate-700 flex flex-col items-start justify-start gap-[24px] overflow-x-auto client-report-dtnamic-tbl">
            <table className="table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv">
              <thead className="bg-surface-bg-secondary dark:bg-slate-600">
                <tr>
                  <th className="relative  text-sm dark:text-white tdth-custom-width">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus">Task</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width">
                    <span className="relative commandtbl-top top-removed-dv">What it is</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv ">Method</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width ">
                    <span className="relative commandtbl-top top-removed-dv ">Due</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width">
                    <span className="relative commandtbl-top top-removed-dv">Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus"><span className="bluestatus"></span> W-5102</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv">Magnolia Home Care · Toni</span>
                    <span className="">She asked for a person, twice. Talent drain, 48 clients, opened A5 and not A6.</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv "> <span className="method-status">M14</span> </span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm ">
                    <span className="relative commandtbl-top top-removed-dv ">in 58 min</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm due-status-bg">
                    <span className="relative commandtbl-top top-removed-dv due-status">58 min left of two hours</span>
                  </td>

                </tr>
                <tr>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus"><span className="bluestatus"></span> W-5102</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv">Magnolia Home Care · Toni</span>
                    <span className="">She asked for a person, twice. Talent drain, 48 clients, opened A5 and not A6.</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv "> <span className="method-status">M14</span> </span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm ">
                    <span className="relative commandtbl-top top-removed-dv ">in 58 min</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm bluedue-status-bg">
                    <span className="relative commandtbl-top top-removed-dv bluedue-status">58 min left of two hours</span>
                  </td>

                </tr>
                <tr>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus"><span className="bluestatus"></span> W-5102</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv">Magnolia Home Care · Toni</span>
                    <span className="">She asked for a person, twice. Talent drain, 48 clients, opened A5 and not A6.</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv "> <span className="method-status">M14</span> </span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm ">
                    <span className="relative commandtbl-top top-removed-dv ">in 58 min</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm bluedue-status-bg">
                    <span className="relative commandtbl-top top-removed-dv yellowdue-status">58 min left of two hours</span>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="m-0 w-full self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
        <h5 className="my-0 text-xl-dv self-stretch relative text-base">This week</h5>

        <div className="mytask-blog-dv viewdoclist_tabel_blg min-w-full overflow-hidden assessorform_main_tbl client-hist-main">
          <div className=" bg-white dark:dark:bg-slate-700 flex flex-col items-start justify-start gap-[24px] overflow-x-auto client-report-dtnamic-tbl">
            <table className="table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv">
              <thead className="bg-surface-bg-secondary dark:bg-slate-600">
                <tr>
                  <th className="relative  text-sm dark:text-white tdth-custom-width">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus">Task</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width">
                    <span className="relative commandtbl-top top-removed-dv">What it is</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv ">Method</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width ">
                    <span className="relative commandtbl-top top-removed-dv ">Due</span>
                  </th>
                  <th className="relative  text-sm dark:text-white tdth-custom-width">
                    <span className="relative commandtbl-top top-removed-dv">Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus"><span className="bluestatus"></span> W-5102</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv">Magnolia Home Care · Toni</span>
                    <span className="">She asked for a person, twice. Talent drain, 48 clients, opened A5 and not A6.</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv "> <span className="method-status">M14</span> </span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm ">
                    <span className="relative commandtbl-top top-removed-dv ">in 58 min</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm due-status-bg">
                    <span className="relative commandtbl-top top-removed-dv due-status">58 min left of two hours</span>
                  </td>

                </tr>
                <tr>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv main-redstatus"><span className="bluestatus"></span> W-5102</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm">
                    <span className="relative commandtbl-top top-removed-dv">Magnolia Home Care · Toni</span>
                    <span className="">She asked for a person, twice. Talent drain, 48 clients, opened A5 and not A6.</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                    <span className="relative commandtbl-top top-removed-dv "> <span className="method-status">M14</span> </span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm ">
                    <span className="relative commandtbl-top top-removed-dv ">in 58 min</span>
                  </td>
                  <td className="tdth-custom-width dark:text-white text-sm bluedue-status-bg">
                    <span className="relative commandtbl-top top-removed-dv graydue-status">Not started</span>
                  </td>

                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 mq1400:grid-2 mq1356:grid-2 mq1275:grid-cols-2 mq950:grid-cols-1 mq575:grid-cols-1 gap-[16px] min-w-full">
        <div className="m-0  self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
          <div className="flex flex-row items-center justify-start gap-[5px] text-2xl w-full">
              <h5 className="my-0 text-xl-dv self-stretch relative text-base">What your work moved</h5><span>read in Kranum</span>
          </div>

          <div className="viewdoclist_tabel_blg overflow-hidden w-full assessorform_main_tbl client-hist-main grid">
            <div className=" bg-white dark:dark:bg-slate-700 flex flex-col items-start justify-start gap-[24px] overflow-x-auto client-report-dtnamic-tbl">
              <table className="table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv">
                <tbody>
                  <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv">M14 · a person, two business hours</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv "> <b>34 of 38 answered</b></span>
                    </td>
                    
                  </tr>
                  <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv">M06 · voice memo</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv "> <b>18 moved · +11 pts vs holdout</b></span>
                    </td>
                    
                  </tr>
                  <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv">M03 · live chat</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv "> <b>34 maps run in chat</b></span>
                    </td>
                    
                  </tr>
                   <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv">M12 · owner session</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv "> <b>9 attended, then watched</b></span>
                    </td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <p className="text-sm dark:text-white">You do the work here. <b>Kranum shows what it moved</b> — these four methods are the ones your tasks serve this month.</p>
          </div>
        </div>
        <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
          <h5 className="my-0 text-xl-dv self-stretch relative text-base">Standing rules on every task</h5>

           <div className="viewdoclist_tabel_blg w-full overflow-hidden assessorform_main_tbl client-hist-main grid">
            <div className=" bg-white dark:dark:bg-slate-700 flex flex-col items-start justify-start gap-[24px] overflow-x-auto client-report-dtnamic-tbl">
              <table className="table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv">
                <tbody>
                  <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv"><span className="text-xs flex-shrink-0 human-bg-dv">Human</span> M14 · a person, two business hours</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv ">never waived</span>
                    </td>
                    
                  </tr>
                  <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv"><span className="text-xs flex-shrink-0 human-bg-dv">Human</span> M14 · a person, two business hours</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv ">never waived</span>
                    </td>
                    
                  </tr>
                  <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv"><span className="text-xs flex-shrink-0 human-bg-dv">Human</span> M14 · a person, two business hours</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv ">never waived</span>
                    </td>
                    
                  </tr>
                   <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv"><span className="text-xs flex-shrink-0 human-bg-dv">Human</span> M14 · a person, two business hours</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv ">never waived</span>
                    </td>
                    
                  </tr>
                   <tr>
                    <td className="tdth-custom-width dark:text-white text-sm">
                      <span className="relative commandtbl-top top-removed-dv"><span className="text-xs flex-shrink-0 lint-bg-dv">LINT</span> M14 · a person, two business hours</span>
                    </td>
                    <td className="tdth-custom-width dark:text-white text-sm method-status-bg">
                      <span className="relative commandtbl-top top-removed-dv ">never waived</span>
                    </td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <p className="text-sm dark:text-white">You do the work here. <b>Kranum shows what it moved</b> — these four methods are the ones your tasks serve this month.</p>
          </div>
        </div>
      </div>
    </div>

  )
}

export default TasksMain